<div *transloco="let t;" class="h-full relative flex ">
  <div class="page-container">
    <router-outlet></router-outlet>
  </div>
  <!--<language-switch id="languageSwitchID" [direction]="switchLanguagePosition" class="fixed z-20 top-90 left-2 sm:bottom-6 sm:left-6"></language-switch>-->
</div>
